module.exports = __webpack_public_path__ + "img/hr-tree-04-g-leaves.8afa031a.png";